import { Overlay, Loading } from 'vant';
import { Toast } from 'vant';
import tools from "../../utils/Tools";
import { sendOauth } from "../../api/user";
import Storage from "../../utils/Storage";
Toast.setDefaultOptions({
  duration: 5000
});
export default {
  name: 'Oauth',
  components: {
    [Overlay.name]: Overlay,
    [Loading.name]: Loading
  },
  data() {
    return {
      show: true
    };
  },
  created() {
    if (tools.isWeiXin()) {
      let params = {
        code: this.$route.query.code,
        access_token: this.$route.query.state
      };
      // axios.post('',params).then(result => {
      //   alert('login')
      //   console.log(params);
      //   return;
      //
      // }).catch(err => {
      //       alert('请先点击确定,再点击右下角使用完整服务')
      // })
      sendOauth(params).then(result => {
        Storage.set('users', result.token);
        // if(result.status == 2){
        //     this.$store.commit("UPDATEUSERS",result.data);
        //     let path = this.$storage.get("VUE_REFERER");
        //     this.$storage.delete("VUE_REFERER");
        //     if(!path){
        //         path = "/";
        //     }
        //     path = "/";
        //     // this.$router.push('/');
        // }else{
        //     Toast(result.info);
        //     // this.$router.push('/');
        // }
      }).catch(err => {
        alert('请先点击确定,再点击右下角使用完整服务');
      });
    } else {
      // this.$router.push('/');
    }
  },
  methods: {}
};